module.exports = __webpack_public_path__ + "img/arrow-left.03ab7769.svg";